<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.push({ name: 'Home' })"
        >
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br/><br/>
        <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary-text">{{ title }}</div>
        <br/>
        <div v-if="user.excedente">
          <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
            <v-alert
              prominent
              type="info"
            >
            Ya no es posible inscribirte a materias ya que estas excento
            </v-alert>
          </v-col>
        </div>
        <div v-else-if="cursos.length == 0 && show == true">
          <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12"
          >
            <v-alert
              prominent
              type="info"
            >
            No hay materias optativas
            </v-alert>
          </v-col>
        </div>
        <div v-else>
          <div
            v-frag
            v-for="(curso, index) in cursos"
            :key="index"
          >
            <div
              class="text-xs-h5 text-sm-h5 text-md-h5 text-lg-h5 text-xl-h5 primary--text"
            >
              {{ curso.nombre }}
            </div>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Examen
                    </th><th class="text-left">
                      Optativa
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(planDeEstudioData,
                    planDeEstudioDataKey) in curso.plan_de_estudio_v2"
                    :key="planDeEstudioDataKey"
                  >
                    <td>{{ planDeEstudioData.Materia }}</td>
                    <td>
                     <v-select
                        v-model="planDeEstudioData.materiaOptativa_id"
                        :items="optativas"
                        item-text="materia"
                        item-value="id"
                        label="Seleccionar"
                        persistent-hint
                        return-object
                        single-line
                        v-on:change="saveOptativa(planDeEstudioData.materia_id, planDeEstudioData.materiaOptativa_id)"
                      ></v-select>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <br/><br/>
        </div>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Optativa",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
  },

  data: () => ({
    title:"Materias optativas",
    cursos:[],  
    optativas:[], 
    show: false, 
  }),
  
  methods:{
    async saveOptativa(id, cambio) {
      await this.$API
        .post({
          url: "alumno/cambio-optativas",
          data: {
            id:id,
            cambio:cambio.id,
          }
        })
        .then(() => {
          this.mesaDeMateria();
        });  
    },
    async cancelarInscripcionMesaMateria(id) {
      await this.$API
        .post({
          url: "materia/cancelar-inscripcion",
          data: {
            id: id
          }
        })
        .then(() => {
          this.mesaDeMateria();
        });
    },
    async mesaDeMateria() {
      await this.$API
        .get({
          url: "materia/mesas",
          data: {}
        })
        .then(res => {
          this.materias = res;
        });
    },
    async getOptativas() {
      await this.$API
        .get({
          url: "optativas",
          data: {}
        })
        .then(res => {
          console.log(res);
          this.optativas = res;
        });
    },
    async getMateriaOptativas() {
      await this.$API
        .get({
          url: "alumno/materia-optativa",
          data: {}
        })
        .then(res => {
          this.cursos = res.data;
          this.show = true;
        });
    },
  },

  mounted() {
    if(this.$store.getters.user.borrado == 1 ||  this.$store.getters.user.alumno_mora ==  true){
      this.$router.push({
          name: "Home"
        });
    }
    this.getMateriaOptativas();
    this.getOptativas();
  },

  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
};
</script>
